import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
// mui
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';
// component
import AppHeader from '@/component/common/app-header';
import ArrowLinkButton from '@/component/common/arrow-link-button';
import UserInfo from '@/component/common/user-info';
import CoinStatus from './CoinStatus';
import ChainList from './ChainList';
import ActionBtns from './ActionBtns';
import BottomRefresh from './BottomRefresh';
// lib & etc
import { useChainId } from 'wagmi';

export default function Connect() {
  const { t } = useTranslation();
  const theme = useTheme();
  const [isChainId, setIsChainId] = useState(false);
  const [anchorElLanguage, setAnchorElLanguage] = useState<HTMLButtonElement | null>(null);
  const [isRefresh, setIsRefresh] = useState(true);
  const [isChainChanging, setIsChainChanging] = useState(false);

  // 체인 ID 변경 감지
  const chainId = useChainId();

  // 체인 변경 시 상태 관리
  useEffect(() => {
    if (chainId) {
      setIsChainChanging(true);
      // 체인 변경 완료 후 상태 초기화
      const timer = setTimeout(() => {
        setIsChainChanging(false);
      }, 1000);

      return () => clearTimeout(timer);
    }
  }, [chainId]);

  const handleOpenLanguagePopover = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorElLanguage(event.currentTarget);
    setIsChainId(true);
  };

  return (
    <Box bgcolor={theme.palette.primary.main} minHeight={750}>
      <Box display="flex" flexDirection="column" height="100%" gap={4}>
        <Container maxWidth="sm">
          <AppHeader title={t('title.walletConnect')} />
          <UserInfo />
          <ActionBtns />
        </Container>
        <Box
          pt={5}
          left={0}
          bottom={0}
          flex={1}
          width="100%"
          sx={{
            bgcolor: 'white',
            '&': {
              borderTopLeftRadius: '30px',
              borderTopRightRadius: '30px',
            },
          }}
        >
          <Container maxWidth="sm">
            <Stack direction="row" justifyContent="space-between" alignItems="center" mb={2.5}>
              <Typography variant="h6" fontWeight={700}>
                {t('validation.myWallet')}
              </Typography>
              {/* TODO 네트워크 변경 완료, 네트워크 추가를 원할경우 web3auth dashboard 및 Network.tsx 추가*/}

              {/* <ArrowLinkButton onClick={handleOpenLanguagePopover as any}>Chains</ArrowLinkButton>
              {isChainId && (
                <ChainList isChainId={isChainId} setIsChainId={setIsChainId} anchorElLanguage={anchorElLanguage} />
              )} */}
            </Stack>
            <Stack minHeight={314} gap={1}>
              {/* 체인이 바뀔 때 리렌더링을 하기 위해 key 값을 체인 ID로 설정 */}
              <CoinStatus key={chainId} />
            </Stack>
          </Container>
        </Box>
      </Box>

      <BottomRefresh isRefresh={isRefresh} setIsRefresh={setIsRefresh} />
    </Box>
  );
}
